<ng-template #animaleNotaControlCPPCModal let-modal="close">
  <div class="modal-header">
    <h3 class="modal-title">Animale Notă control CPPC</h3>

    <div class="col-sm-12 col-md-12 col-lg-6 text-right custom-col">
      <div class="btn-group custom-modal-btn">
        <button
          class="btn btn-sm btn-secondary"
          (click)="modal('Cross click')"
          autofocus="false"
        >
          Închide
        </button>

        <button
          *ngIf="isAdmin || isOperator"
          class="btn btn-sm btn-success"
          (click)="onSubmitted()"
        >
          Salvează
        </button>
      </div>
    </div>
  </div>

  <div class="modal-body">
    <div class="container-fluid">
      <div class="row mb-1">
        <div class="col-sm-12 col-lg-3">
          <div class="h4">Exploatația</div>
          <div class="h5">{{ animalInfo["nume_exploatatie"] }}</div>
        </div>

        <div class="col-sm-12 col-lg-3">
          <div class="h4">Notă control CPPC</div>
          <div class="h5">
            {{ animalInfo["numar"] }} / {{ animalInfo["data_dmy"] }}
          </div>
        </div>

        <div class="col-sm-12 col-lg-3">
          <div class="h4">Operator control</div>
          <div class="h5">{{ animalInfo["nume_operator"] }}</div>
        </div>

        <div class="col-sm-12 col-lg-3">
          <div class="h4">Fișier</div>
          <span
            *ngIf="animalInfo['file_name']"
            class="file-button"
            (click)="downloadFile($event)"
          >
            {{ animalInfo["file_name"] }}
          </span>
        </div>
      </div>

      <h4 class="mb-3">
        <input
          type="checkbox"
          (click)="clickToateAnimalele($event)"
          class="square_1_point_5 mr-3"
          [(ngModel)]="checkboxToateAnimalele"
        />

        Animale active neîncadrate
      </h4>

      <ng-container
        *ngFor="let animalForm of animalArrayForm.controls; let index = index"
      >
        <div [formGroup]="animalForm" class="row align-items-center mb-2">
          <div class="col-auto">
            <input
              type="checkbox"
              formControlName="selectat"
              class="d-flex align-self-center square_1_point_5"
              [id]="'selectat_' + index"
              (click)="clickCheckboxAnimal()"
            />
          </div>

          <div class="col-auto">
            <label
              [for]="'selectat_' + index"
              class="d-flex align-items-center m-0 fs-4"
            >
              <ng-container [ngSwitch]="animalInfo['animale'][index].sex">
                <span *ngSwitchCase="1" class="box-mascul">M</span>
                <span *ngSwitchCase="2" class="box-femela">F</span>
              </ng-container>

              <span
                [ngClass]="{
                  'color-mascul': animalInfo['animale'][index].sex === 1,
                  'color-femela': animalInfo['animale'][index].sex === 2
                }"
                >{{ animalInfo["animale"][index].numarmatricol }}</span
              >
            </label>
          </div>

          <div class="col-auto d-flex align-items-center fs-5">
            {{ animalInfo["animale"][index].rasa }}

            <a
              *ngIf="animalInfo['animale'][index].id"
              [routerLink]="
                '/dashboard/animal/' + animalInfo['animale'][index].id
              "
              target="_blank"
              class="ml-2 fs-3"
              ><i class="mdi mdi-open-in-new mr-1"></i
            ></a>
          </div>

          <div class="col-auto d-flex align-items-center fs-5">
            <span
              *ngFor="let error of animalInfo['animale'][index].errors"
              class="badge badge-danger p-1 mr-2"
            >
              {{ error }}
            </span>
            <span
              *ngFor="let warning of animalInfo['animale'][index].warnings"
              class="badge badge-warning text-dark p-1 mr-2"
            >
              {{ warning }}
            </span>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>
